import { addProp } from "@pnp/odata";
import { _List } from "../lists/types.js";
import { Folder } from "./types.js";
addProp(_List, "rootFolder", Folder, "rootFolder");
//# sourceMappingURL=list.js.map